<template>
  <div class="">
    <div class="head-title">合同审批流程</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>
            1、企业添加管理合同、回款等不同的审批流程，设置审批流程步骤及审批人，发起审批后将按顺序审批直至最后一个人。
          </p>
          <p>
            2、删除审批人的时候如果该审批人下面有待审批合同/回款将会自动转入下一级审批人，如果没有下一级审批人待审批合同/回款的状态将自动变成完成状态。
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>

    <div class="mMain">
      <div class="tianjia">
        <div class="cut">
          <span @click="contract()" :class="aaa == true ? 'a' : ''">合同</span>
          <span @click="money()" :class="bbb == true ? 'a' : ''">回款</span>
        </div>
        <div style="margin-top: 2.0rem">
          <!-- 根据员工检索 -->
          <div v-if="aaa == true" class="staffo_home">
            <number></number>
          </div>
          <!-- 根据客户检索 -->
          <div v-if="bbb == true" class="staffo_home">
            <money></money>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import Money from "../../components/flow/money";
import Number from "../../components/flow/number";
export default {
  data() {
    return {
      aaa: true,
      bbb: false,
    };
  },
  mounted() {
    // 页面刷新就请求到数据渲染到页面中
    // get请求页面的数据
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
  },
  components: {
    Money,
    Number,
  },
  methods: {
    contract() {
      this.aaa = true;
      this.bbb = false;
    },
    money() {
      this.aaa = false;
      this.bbb = true;
    },
  },
};
</script>
<style scoped>
.home {
  width: 100%;
  height: 100%;
}
.wei_body {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  padding: 2.3rem 3.1rem;
}
.tianjia {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
}
.tianjia > main {
  font-size: 2.6rem;
}
.bule {
  width: 100%;
  height: 6.9rem;
  background-color: #2890dd;
  z-index: 10;
  position: absolute;
  top: .0rem;
  left: .0rem;
}
.ovued {
  margin: 0 auto;
  width: 7.0rem;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.aaas {
  color: blue;
}
.cut {
  border-bottom: .1rem solid #eee;
}
.cut > span {
  display: inline-block;
  text-align: center;
  cursor: pointer;
  padding: 1.2rem;
  margin-right: 3.0rem;
  font-weight: 500;
  font-size: 2.2rem;
}
.a {
  color: #49B372;
  border-bottom: .2rem solid;
}
.staffo_home {
  width: 100%;
  height: 100%;
}
</style>
